module.exports = "/assets/regin-jumpers.png";